import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import ar from "@/i18n/ar.json";

// Thank You page is SPANISH ONLY per spec, regardless of any UI locale
export const ThankYou = () => {
  const t = ar.thankyou;
  return (
    <div className="flex min-h-[70vh] items-center justify-center bg-[#FAFAFC] px-4 py-16">
      <div
        data-testid="thankyou-card"
        className="w-full max-w-2xl rounded-sm border border-slate-200 bg-white p-8 text-center sm:p-12"
      >
        <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-[#0F2C59] text-white">
          <CheckCircle2 size={28} />
        </div>
        <h1
          data-testid="thankyou-title"
          className="font-serif text-3xl font-bold text-[#0F2C59] sm:text-4xl"
        >
          {t.title}
        </h1>
        <p className="mt-3 text-base font-semibold text-[#C85A32]">{t.subtitle}</p>
        <p className="mt-5 text-base leading-relaxed text-slate-700">{t.message}</p>
        <p className="mt-4 text-sm leading-relaxed text-slate-500">{t.note}</p>
        <Link
          to="/"
          data-testid="thankyou-back-home"
          className="mt-8 inline-flex items-center gap-2 rounded-sm bg-[#0F2C59] px-6 py-3 text-sm font-semibold text-white hover:bg-[#153970]"
        >
          <ArrowLeft size={16} />
          {t.back_home}
        </Link>
      </div>
    </div>
  );
};

export default ThankYou;
